import axios from 'axios'
import { ihFaceDetectUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 上传数据生成特征码
export function voiceCreate(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/create'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('声纹识别', '上传数据生成特征码', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除人脸数据
export function voiceDelete(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/delete/' + params.id
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('声纹识别', '删除人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 分页查询人脸数据
export function voicePageList(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('声纹识别', '分页查询人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}
// 修改人脸数据
export function voiceUpdate(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('声纹识别', '修改人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 上传数据生成特征码
export function voiceCreateByLogId(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/' + params.logId + '/create?voiceUserName=' + params.voiceUserName
  return axios({
    method: 'post',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音识别记录', '注册升温', res)
    }
    return Promise.resolve(res.data)
  })
}
